module.exports = __webpack_public_path__ + "img/jcb.6e57f12e.png";